{
  "cms.previewFrame.loading": "Loading preview…",
  "cms.previewFrame.unavailable.title": "Preview is not available",
  "cms.previewFrame.unavailable.body": "This preview is for CMS admins only. Sign in as an admin to continue.",
  "cms.preview.description": "Live preview of the draft as members will see it.",
  "cms.preview.device.desktop": "Desktop",
  "cms.preview.device.label": "Device",
  "cms.preview.device.mobile": "Mobile",
  "cms.preview.frameTitle": "Preview of the member page",
  "cms.preview.shapeUnavailable": "Preview is not available for this content type yet.",
  "cms.preview.title": "Preview (draft + published)",
  "cms.preview.zoom.label": "Zoom",
  "cms.viewport.desktopRequired.body": "Content management requires a desktop-sized screen. Please continue from a workstation browser.",
  "cms.viewport.desktopRequired.title": "Content management requires a desktop"
}
